import isEmpty from "lodash/isEmpty";
import * as api from "../api/adapters/json_api";

const type = "quotations";
const path = `api_resources/${type}`;

export default {
  /**
   * FIN-1247: the Sellwisor block of the Dashboard's Purchasing section,
   * GET /api_resources/quotations/dashboard_purchasing. No vessels means every vessel
   * the user may see; 'all' for importance or type means no filter and is not sent.
   * @returns {Promise<Object>} the block, as the backend's `data`
   */
  dashboardPurchasing: ({ vesselIds, importance, type: rlType } = {}) => api
    .read({ type: path, id: "dashboard_purchasing" }, {
      query: {
        vessel_ids: vesselIds,
        importance: importance === "all" ? undefined : importance,
        type: rlType === "all" ? undefined : rlType,
      },
    })
    .then((response) => response.data.data),

  /**
   * getQuotation
   * @returns {Promise<*>}
   */
  show: (id) => api.read({ type, id }, {}),

  index: (attributes) => {
    const { filter } = attributes;
    return api.read(
      { type: path },
      {
        query: {
          filter: {
            ...filter,
          },
        },
      }
    );
  },
};
